import glossary from '../../../data/glossary.json';

export const constructKpis = (googleResponse) => {
    let kpis = []
    for ( const kpi of Object.entries(googleResponse.metrics) ) {
        const kpiKey = kpi[0];
        const kpiValue = kpi[1];
        const glossaryMatchingKpi = glossary.kpis[kpiKey];

        if ( glossaryMatchingKpi ) kpis.push({
            key: glossaryMatchingKpi, 
            originalKey: glossaryMatchingKpi, 
            value: parseFloat(kpiValue)
        })
    }
    return kpis;
}